/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Dlh_HInputs */

const en_wc_dlh_h = /** @type {(inputs: Wc_Dlh_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WordCraft downloads, explained`)
};

/**
* | output |
* | --- |
* | "WordCraft downloads, explained" |
*
* @param {Wc_Dlh_HInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_dlh_h = /** @type {((inputs?: Wc_Dlh_HInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Dlh_HInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_dlh_h(inputs)
});
export { wc_dlh_h as "wc.dlh.h" }